let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/radio");
let esUtils = require("ES/utils/esUtils");
let dateformat = require("ES/lib/dateformat");
let esStatusImage = require("../esStatusImage");
let getResultDates = require("./getResultDates");
let AuthedUserSession = require("../../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  __onClick: esUtils.wrapPreventDefault(function () {
    let {result} = this.props;
    radio("Hashbang_set").broadcast("/events/" + result.eid);
  }),
  render() {
    let {indent, result, Displaylists} = this.props;

    let d = result.this_result_date;

    let n_child_days = 0;
    if (_.size(getResultDates(result)) <= 1) {//only show child days if we only have on result
      n_child_days = esUtils.toInt(result.n_child_days);
    }

    //tack on the company name if it's not the active company or it's child
    let event_company_id = _.parseInt(_.get(result, ["companyID"]));
    let companylabel = "";
    if (event_company_id !== _.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"])) {
      let company = _.find(_.get(Displaylists, ["universal", "company"]), {'id': event_company_id});
      if (_.parseInt(_.get(company, "prnt", 0)) !== _.parseInt(_.get(AuthedUserSession, ["activeCompany", "COMPANY_ID"]))) {
        companylabel = " [" + _.get(company, "abbr", event_company_id) + "]";
      }
    }

    return dd.div({className: "clickable", onClick: this.__onClick},
      dd.div({style: {marginLeft: indent, padding: "3px 0"}},
        dd.div({className: "pull-left"},
          esStatusImage({
            size: 20,
            status: _.get(result, "status"),
            closed: ((_.get(result, "flags", 0) & 4) > 0),
            delivery_method: _.get(result, "deliverymethod"),
            has_parent: _.get(result, "parentID", 0) > 0,
            has_children: _.get(result, "n_child_events", 0) > 0
          })
        ),
        dd.div({style: {marginLeft: 30}},
          _.isDate(d) ? dateformat(d, "d") + ": " : "",
          _.get(result, "organization", null),
          " ",
          _.get(result, "meetingname", null),
          n_child_days > 1 ? " (" + n_child_days + " Days)" : null,
          companylabel
        ),
        dd.div({className: "clearfix"})
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/TreeSearch/Result.js